import sliderLayoutController from '../global/sliderLayoutController';
import updateHeightOfRelatedContent from '../helpers/updateHeightOfRelatedContent';

const relatedContent = () => {
	const relatedResources = Array.from(document.getElementsByClassName("related-resources"));
	const relatedPosts = Array.from(document.getElementsByClassName("related-posts"));
	const mixedContent = Array.from(document.getElementsByClassName("mixed-content"));

	if (relatedResources.length > 0) {
		sliderLayoutController('related-resources__list-wrapper', 3, null, "full", '.related-resources__prev', '.related-resources__next');
		updateHeightOfRelatedContent();
	}

	if (relatedPosts.length > 0) {
		sliderLayoutController('related-posts__list-wrapper', 3, null, "full", '.related-posts__prev', '.related-posts__next');
		updateHeightOfRelatedContent();
	}

	if (mixedContent.length > 0) {
		sliderLayoutController('mixed-content__list-wrapper', 3, null, "full", '.mixed-content__prev', '.mixed-content__next');
		updateHeightOfRelatedContent();
	}
}

export default relatedContent;
